import React from 'react';
import '@guest-widgets/shared/src/utils/enableDevTools';
import { QueryRouter } from '@guest-widgets/shared/src/components/Router/QueryRouter';
import { FeatureProvider } from '@guest-widgets/shared/src/contexts/featureContext/featureContext';
import { ConfigurationTheme } from '@guest-widgets/shared/src/components/ConfigurationTheme/ConfigurationTheme';

import { Routes } from './Routes';
import { SettingsConsumer, SettingsContextProps, SettingsProvider } from './settingsContext';
import { FiltersProvider } from './filtersContext/filtersContext';
import { ProductsProvider } from './productsContext';
import { FilterAttributesProvider } from './filterAttributesContext';
import { LocalizationProvider } from './LocalizationProvider';
import { Filters } from './filters';
import { ApiContextProvider } from './Catalog/contexts/apiContext';

export type AppProps = SettingsContextProps;

export const App = (props: AppProps) => (
  <QueryRouter>
    <ApiContextProvider>
      <SettingsProvider {...props}>
        <SettingsConsumer>
          {({
            categoryFilter,
            locationFilter,
            disableFeatures,
            enableFeatures,
            configuration,
            disableDownloadFont,
          }) => (
            <LocalizationProvider>
              <FeatureProvider disable={disableFeatures} enable={enableFeatures}>
                <FilterAttributesProvider>
                  <FiltersProvider
                    initialState={mapToInitialFilters(categoryFilter, locationFilter)}
                  >
                    <ConfigurationTheme
                      configuration={configuration}
                      disableDownloadFont={disableDownloadFont}
                    >
                      <ProductsProvider>
                        <Routes />
                      </ProductsProvider>
                    </ConfigurationTheme>
                  </FiltersProvider>
                </FilterAttributesProvider>
              </FeatureProvider>
            </LocalizationProvider>
          )}
        </SettingsConsumer>
      </SettingsProvider>
    </ApiContextProvider>
  </QueryRouter>
);

const mapToInitialFilters = (
  categories?: Filters['categories'],
  location?: Filters['location']
): Partial<Filters> => ({
  ...(categories?.length ? { categories } : {}),
  ...(location ? { location } : {}),
});

export default App;
